import { useContext } from "react";
import { authContext } from "../context/auth/AuthContext";
import NotFound from "../components/layout/NotFound/NotFound";

export const ProtectedRoute = ({ children }) => {
  const { user } = useContext(authContext);

  if (!user?.auth) {
    return <NotFound />;
  }

  return children;
};

export default ProtectedRoute;
